/**
 * This was added to solve an issue where strings representing numbers that had commas (e.g. '1,234.56') were
 * having problems being converted into numbers. See https://observablehq.com/@mbostock/localized-number-parsing
 * for more help on what this does
 */
export class NumberParser {
  _group: RegExp
  _decimal: RegExp
  _numeral: RegExp
  _index: (d: string) => number | undefined

  constructor(locale) {
    const parts = new Intl.NumberFormat(locale).formatToParts(12345.6)
    const numerals = [
      ...new Intl.NumberFormat(locale, { useGrouping: false }).format(
        9876543210
      ),
    ].reverse()
    const index = new Map(numerals.map((d, i) => [d, i]))
    this._group = new RegExp(
      `[${parts.find((d) => d.type === 'group')?.value}]`,
      'g'
    )
    this._decimal = new RegExp(
      `[${parts.find((d) => d.type === 'decimal')?.value}]`
    )
    this._numeral = new RegExp(`[${numerals.join('')}]`, 'g')
    this._index = (d) => index.get(d)
  }
  parse(string) {
    const transformedString = string
      .trim()
      .replace(this._group, '')
      .replace(this._decimal, '.')
      .replace(this._numeral, this._index)
    return transformedString ? +transformedString : NaN
  }
}
